import React from 'react';

const SimpleBarChart = ({ data, title, color = 'bg-blue-500' }) => {
    const maxValue = Math.max(...data.map(d => d.value), 1); // Avoid div by zero

    return (
        <div className="bg-white p-6 rounded-[2rem] border border-slate-200 shadow-sm flex flex-col h-full">
            <h3 className="text-lg font-bold text-slate-800 mb-6">{title}</h3>
            <div className="flex items-end justify-between flex-grow gap-2 h-40">
                {data.map((item, index) => (
                    <div key={index} className="flex flex-col items-center flex-1 group">
                        <div className="relative w-full flex justify-center">
                            <div 
                                style={{ height: `${(item.value / maxValue) * 100}%` }} 
                                className={`w-full max-w-[24px] rounded-t-lg transition-all duration-500 ${color} opacity-80 group-hover:opacity-100`}
                            ></div>
                            <div className="absolute -top-8 opacity-0 group-hover:opacity-100 transition-opacity bg-slate-800 text-white text-[10px] px-2 py-1 rounded">
                                {item.value}
                            </div>
                        </div>
                        <span className="text-[10px] font-bold text-slate-400 mt-2 uppercase tracking-wide">{item.label}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SimpleBarChart;
